/**
 * NLB-GW
 *
 * Contact: service@rheinenergie.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Feedback vom Kunden
 */
export interface Feedback { 
    bewertung?: number;
    kommentar?: string;
    /**
     * accountId of existing contract, also knows as VK
     */
    accountId?: string;
    pfad?: string;
    userAgent?: string;
    aufloesung?: string;
    /**
     * Email address
     */
    email?: string;
    istFehler?: boolean;
}

